var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuetify-wrapper" },
    [
      _c("appointment-creator", {
        attrs: {
          appointment: JSON.parse(_vm.appointment),
          pharmacy: JSON.parse(_vm.pharmacy),
        },
        on: { "fetch-appointments": _vm.save },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }